import moment from 'moment';
import { getMaintenanceUrl } from '../containers/Maintenance/MaintenanceStatus/epics.maintenanceStatus';
import { getServiceRecordsUrl } from '../containers/Maintenance/ServiceRecords/epics.recordList';
import {
    getUserSettingTimeZone,
    getRequiredDateFormatFromUserSettings,
    getDistanceStringLong,
    downloadFile,
    getContentType,
} from '../helper-classes/utility-functions';

const handleDialogDownload = ({
    page,
    rowsPerPage,
    order,
    orderBy,
    selectedFilters,
    selectedOption,
    setLoading,
    closeExport,
    isMaintenanceStatus,
}) => {
    closeExport(false);
    setLoading(true);

    const urlGenerator = isMaintenanceStatus ? getMaintenanceUrl : getServiceRecordsUrl;
    let url = urlGenerator(
        {
            pageNumber: page,
            pageSize: rowsPerPage,
            order,
            orderBy,
            filtersToSend: selectedFilters,
        },
        false,
    );

    url = `${url}&timezone=${getUserSettingTimeZone()}&dateFormat=${getRequiredDateFormatFromUserSettings()}&unitOfMeasurement=${getDistanceStringLong()}`;

    downloadFile(
        url,
        `${isMaintenanceStatus ? 'Maintenance Status' : 'Service Records'} ${moment().format('YYYY-MM-DD HH-mm-ss')}.${selectedOption.value}`,
        {
            type: selectedOption.value,
            headers: { Accept: getContentType(selectedOption.value) },
        },
        () => setLoading(false),
    );
};
export default handleDialogDownload;
